import React, { useCallback, useState } from 'react'
import { Menu, Segment } from 'semantic-ui-react'
import { Link, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { isInvalid } from 'redux-form'
import prop from 'lodash/fp/prop'

interface IOwnProps {
  formName?: string
  buttons?: JSX.Element
  children: React.ReactNode
}

type TabsProps = IOwnProps

const errorStyle = {
  color: '#db2828',
  fontWeight: 'bold'
}

const menuStyle = {
  flexWrap: 'wrap-reverse'
}

interface ReduxFromState {
  form: any
}

/**
 * @deprecated move away from redux-form tabs, use/introduce components from @carsys/form
 * */
export const Tabs: React.FC<TabsProps> = props => {
  const form = useSelector<ReduxFromState, any>(state => props.formName && state.form[props.formName])
  const hasFormErrors = useSelector<ReduxFromState, boolean>(state => (props.formName ? isInvalid(props.formName)(state) : false))
  const { hash } = useLocation()
  const [tabConfig, setTabConfig] = useState<{ [key: string]: { [key: string]: {} } }>({})
  const hasError = useCallback(
    (tab: string) => {
      if (!tabConfig[tab]) {
        return false
      }

      if (form && form.fields) {
        for (const field of Object.keys(tabConfig[tab])) {
          if (prop(field, form.syncErrors) || prop(field, form.asyncErrors)) {
            const meta = prop(field, form.fields)
            if (meta && meta.touched) {
              return true
            }
          }
          if (prop(field, form.submitErrors)) {
            const meta = prop(field, form.fields)
            if (meta) {
              return true
            }
          }
        }
      }

      return false
    },
    [tabConfig, form]
  )
  const registerField = useCallback(
    (tab: string, field: string) => {
      if (!tabConfig[tab] || !tabConfig[tab][field]) {
        setTabConfig((prevState: any) => ({ ...prevState, [tab]: { ...prevState[tab], [field]: true } }))
      }
    },
    [tabConfig]
  )

  const { children, buttons } = props
  const childrenArray = React.Children.toArray(children).filter((t: any) => t.props && !t.props.hide)
  const activeTab: any = childrenArray.find((tab: any) => hash === `#${tab.props.name}`) || childrenArray[0]

  return (
    <React.Fragment>
      <Menu attached='top' tabular size='small' style={menuStyle} role='tablist'>
        {childrenArray.map((tab: any) => {
          const hasErrorResult = hasFormErrors && hasError(tab.props.name)
          const disabled = tab.props.disabled

          return (
            <Menu.Item
              key={tab.props.name}
              active={activeTab === tab}
              as={Link}
              replace
              to={`#${tab.props.name}`}
              style={hasErrorResult ? errorStyle : undefined}
              data-testid={`${tab.props.name}-tab`}
              disabled={disabled}
            >
              {tab.props.title}
              {hasErrorResult && '*'}
              {tab.props.label ? tab.props.label : null}
            </Menu.Item>
          )
        })}
        <Menu.Menu position='right'>
          <Menu.Item fitted='horizontally' key={activeTab ? activeTab.props.name : 'noneActiveItem'}>
            {(activeTab && activeTab.props && activeTab.props.buttons && activeTab.props.buttons) || buttons}
          </Menu.Item>
        </Menu.Menu>
      </Menu>
      {childrenArray.map((tab: any) => {
        if (!props.formName && tab !== activeTab) {
          // if it's not a form tab, unmount the inactive tabs
          return null
        }
        return (
          <Segment attached='bottom' key={tab.props.name} className={`flex w100 m0 ${tab === activeTab ? '' : 'd-none'}`} role='tab'>
            {React.cloneElement(tab, { registerField })}
          </Segment>
        )
      })}
    </React.Fragment>
  )
}

/**
 * @deprecated move away from redux-form tabs, use/introduce components from @carsys/form
 * */
export default Tabs
